/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function AreaEditDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { areaForEdit, actionsLoading } = useSelector(
    (state) => ({
      areaForEdit: state.area.areaForEdit,
      actionsLoading: state.channels.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Wilayah Baru";
    if (areaForEdit && id) {
      _title = "Edit Wilayah";
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [areaForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
